<template>
    <div class="wrap" style="margin:0 -12px;">
        <div class="container">
            <div class="row">
                <div class="col px-0">
                    <img src="/images/Group13415.png" class="img-fluid">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-1"></div>
                <div class="col px-0">
                    <div style="padding-right:7.5px;">
                        <img src="/images/Group13416.png" class="img-fluid">
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <div style="padding:0 10px;">
                        <div>
                            <small> イベント名 </small>
                        </div>
                        <input type="text" class="luna-form-control" v-model="thumbnail" placeholder="入力する" />
                        <br />
                        <div>
                            <small> 主催名（イベント詳細ページにて表示されます） </small>
                        </div>
                        <input type="text" class="luna-form-control" v-model="organizer" placeholder="名前・ユーザー名・会社名など" />
                        <br />
                        <div>
                            <small> 開催日時 </small>
                        </div>
                        <div style="width:65%">
                            <input type="date" class="luna-form-control" v-model="event_at" placeholder="" />
                        </div>
                        <br />
                        <div style="width:65%">
                            <v-select name="event_type" :options="event_types" v-model="event_type" placeholder="選択してください"
                                :onchange="setEventTypeVal()">
                            </v-select>
                        </div>
                        <div v-show="event_type_val > 0">
                            <br>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    1部
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    開場
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_open_1" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">

                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    開演
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_from_1" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">

                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    閉演
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_to_1" />
                                </div>
                            </div>
                        </div>
                        <div v-show="event_type_val > 1">
                            <br>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    2部
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    開場
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_open_2" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">

                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    開演
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_from_2" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">

                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    閉演
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_to_2" />
                                </div>
                            </div>
                        </div>
                        <div v-show="event_type_val > 2">
                            <br>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    3部
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    開場
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_open_3" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">

                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    開演
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_from_3" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2 text-end" style="padding-top:15px;">

                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    閉演
                                </div>
                                <div class="col">
                                    <input type="time" step="900" class="luna-form-control" v-model="event_at_to_3" />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div>
                            <small> 開催地域 </small>
                        </div>
                        <div style="width:65%">
                            <v-select name="area_value" :options="areas" v-model="area_value" placeholder="選択してください">
                            </v-select>
                        </div>
                        <br />
                        <div>
                            <small> 開催住所 </small>
                        </div>
                        <input type="text" class="luna-form-control" v-model="address" placeholder="入力する" />
                        <br />
                        <div>
                            <small> 会場名 </small>
                        </div>
                        <input type="text" class="luna-form-control" v-model="venue_name" placeholder="入力する" />
                        <br />
                        <div>
                            <small> 定員・参加人数 </small>
                        </div>
                        <div style="width:65%">
                            <input type="number" class="luna-form-control" v-model="member_count" placeholder="" />
                        </div>
                        <br />
                        <div>
                            <small> 出演者・ゲストの登録 </small>
                            <div style="font-size:12px;color:#999;">
                                出演者・ゲスト名を登録すると、申込者がどの出演者・ゲスト経由で申し込むのかを登録できるようになります。
                            </div>
                        </div>
                        <div style="width:65%">
                            <v-select name="is_player" :options="is_players" v-model="is_player" placeholder="選択してください"
                                :onchange="setPlayerInput()">
                            </v-select>
                        </div>
                        <div v-show="player_type == 1">
                            <div v-for="(player, index) in players" :key="index" style="padding-top:3px;">
                                <div class="row">
                                    <div class="col-3 text-end" style="padding-top:15px">{{ index + 1 }}人目</div>
                                    <div class="col">
                                        <input type="text" class="luna-form-control" v-model="player.value"
                                            placeholder="入力する" />
                                    </div>
                                    <div class="col-1 px-0 text-center" style="padding-top:12px">
                                        <svg style="height:20px;width:20px;fill:#cdcdcd;" @click="rmPlayerInput(index)">
                                            <use xlink:href="/images/x.svg#x"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="text-end" style="padding-top:10px;">
                                <button type="button" class="btn btn-luna" style="padding: 3px 20px 8px 20px;"
                                    @click="addPlayerInput()" id="on-btn">
                                    <i class="bi bi-plus" style="font-size:25px;top: 4px;position: relative;"></i>出演者の追加
                                </button>
                            </div>
                        </div>
                        <br />
                        <div>
                            <small> サムネイル画像 </small>
                        </div>
                        <div>
                            <croppa v-model="myCroppa" :width="250" :height="140" placeholder="" :placeholder-font-size="0"
                                :disabled="false" :prevent-white-space="false" :show-remove-button="true"
                                :initial-image="url" accept=".jpeg,.jpg,.png" @file-type-mismatch="onFileTypeMismatch">
                                <img slot="placeholder" src="/images/Group13419_1.png" height="200" width="200">
                            </croppa>
                            <div class="text-end" style="width:250px;padding-bottom:10px;">
                                <button type="button" class="btn btn-luna" style="font-size: 18px;"
                                    @click="myCroppa.rotate()"><i class="bi bi-arrow-clockwise"></i>
                                </button>
                            </div>
                            <div style="font-size:12px;color:#999;">
                                ■ 推奨サイズ　500px × 280px 以上<br>
                                ■ 形式はjpg/pngが対象です。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row justify-content-center">
                <div class="col-9">
                    <br />
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-luna disabled" style="padding: 12px 0" v-if="is_load">
                            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            次へ
                        </button>
                        <button type="button" class="btn btn-luna" style="padding: 12px 0" @click="setEvent()" id="on-btn"
                            v-else-if="isEventNext()">
                            次へ
                        </button>
                        <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0" id="non-btn" v-else>
                            次へ
                        </button>
                    </div>
                    <p class="error-text text-center" id="error-text_my_like" v-if="!isEventNext()">
                        <i class="bi bi-x-circle-fill"></i>未入力の項目があります。
                    </p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <a href="/event/home" style="font-size:12px;" @click="rmEventInfo()">
                        <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                            <use xlink:href="/images/<.svg#page_left"></use>
                        </svg>&nbsp;イベント管理に戻る</a>
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            thumbnail: "",
            organizer: "",
            member_count: 0,
            event_at: null,
            event_at_open_1: null,
            event_at_from_1: null,
            event_at_to_1: null,
            event_at_open_2: null,
            event_at_from_2: null,
            event_at_to_2: null,
            event_at_open_3: null,
            event_at_from_3: null,
            event_at_to_3: null,
            event_type: [],
            event_types: [
                { value: "0", label: "1部制" },
                { value: "1", label: "2部制" },
                { value: "2", label: "3部制" },
            ],
            event_type_val: 0,
            catch_copy: "",
            event_feature: "",
            event_recommend: "",
            event_summary: "",

            myCroppa: null,
            url: "",

            is_load: false,

            players: [],
            is_player: [],
            is_players: [
                { value: "0", label: "なし" },
                { value: "1", label: "あり" },
            ],
            player_type: 0,

            address: "",
            venue_name: "",
            area_value: null,
            areas: [
                { value: "北海道", label: "北海道" },
                { value: "青森県", label: "青森県" },
                { value: "岩手県", label: "岩手県" },
                { value: "宮城県", label: "宮城県" },
                { value: "秋田県", label: "秋田県" },
                { value: "山形県", label: "山形県" },
                { value: "福島県", label: "福島県" },
                { value: "茨城県", label: "茨城県" },
                { value: "栃木県", label: "栃木県" },
                { value: "群馬県", label: "群馬県" },
                { value: "埼玉県", label: "埼玉県" },
                { value: "千葉県", label: "千葉県" },
                { value: "東京都", label: "東京都" },
                { value: "神奈川県", label: "神奈川県" },
                { value: "新潟県", label: "新潟県" },
                { value: "富山県", label: "富山県" },
                { value: "石川県", label: "石川県" },
                { value: "福井県", label: "福井県" },
                { value: "山梨県", label: "山梨県" },
                { value: "長野県", label: "長野県" },
                { value: "岐阜県", label: "岐阜県" },
                { value: "静岡県", label: "静岡県" },
                { value: "愛知県", label: "愛知県" },
                { value: "三重県", label: "三重県" },
                { value: "滋賀県", label: "滋賀県" },
                { value: "京都府", label: "京都府" },
                { value: "大阪府", label: "大阪府" },
                { value: "兵庫県", label: "兵庫県" },
                { value: "奈良県", label: "奈良県" },
                { value: "和歌山県", label: "和歌山県" },
                { value: "鳥取県", label: "鳥取県" },
                { value: "島根県", label: "島根県" },
                { value: "岡山県", label: "岡山県" },
                { value: "広島県", label: "広島県" },
                { value: "山口県", label: "山口県" },
                { value: "徳島県", label: "徳島県" },
                { value: "香川県", label: "香川県" },
                { value: "愛媛県", label: "愛媛県" },
                { value: "高知県", label: "高知県" },
                { value: "福岡県", label: "福岡県" },
                { value: "佐賀県", label: "佐賀県" },
                { value: "長崎県", label: "長崎県" },
                { value: "熊本県", label: "熊本県" },
                { value: "大分県", label: "大分県" },
                { value: "宮崎県", label: "宮崎県" },
                { value: "鹿児島県", label: "鹿児島県" },
                { value: "沖縄県", label: "沖縄県" },
                { value: "オンライン", label: "オンライン" },
            ],

            event_info: [],
        };
    },
    methods: {
        initEvent() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                let serializedArray = localStorage.getItem('luna_event_entry');
                let event = JSON.parse(serializedArray);
                this.event_info = event

                this.thumbnail = event['thumbnail']
                this.event_at = event['event_at']
                this.event_at_open_1 = event['event_at_open_1']
                this.event_at_from_1 = event['event_at_from_1']
                this.event_at_to_1 = event['event_at_to_1']
                this.event_at_open_2 = event['event_at_open_2']
                this.event_at_from_2 = event['event_at_from_2']
                this.event_at_to_2 = event['event_at_to_2']
                this.event_at_open_3 = event['event_at_open_3']
                this.event_at_from_3 = event['event_at_from_3']
                this.event_at_to_3 = event['event_at_to_3']
                this.event_type = event['event_type']
                this.event_type_val = event['event_type_val']

                this.address = event['address']
                this.area_value = { value: event['area'], label: event['area'] }

                this.is_player = event['is_player']
                this.players = event['players']
                this.player_type = event['player_type']

                this.member_count = event['member_count']
                this.organizer = event['organizer']
                this.venue_name = event['venue_name']
            }
        },
        setEventTypeVal() {
            if (this.event_type == null) {
                this.event_type_val = 0
            }
            else {
                this.event_type_val = Number(this.event_type.value) + 1
            }
        },
        onFileTypeMismatch(file) {
            alert('jpg, gif, png　形式でアップして下さい。')
        },
        setEvent() {
            let event = {
                'thumbnail': this.thumbnail,
                'event_at': this.event_at,
                'event_at_open_1': this.event_at_open_1,
                'event_at_from_1': this.event_at_from_1,
                'event_at_to_1': this.event_at_to_1,
                'event_at_open_2': this.event_at_open_2,
                'event_at_from_2': this.event_at_from_2,
                'event_at_to_2': this.event_at_to_2,
                'event_at_open_3': this.event_at_open_3,
                'event_at_from_3': this.event_at_from_3,
                'event_at_to_3': this.event_at_to_3,
                'event_type': this.event_type,
                'event_type_val': this.event_type_val,

                'address': this.address,
                'area': this.area_value.value,
                'area_value': this.area_value,

                'is_player': this.is_player,
                'players': this.players,
                'player_type': this.player_type,

                'member_count': this.member_count,
                'organizer': this.organizer,
                'venue_name': this.venue_name,
                'img_url': this.myCroppa.generateDataUrl(),


                'catch_copy': (this.event_info['catch_copy'] == undefined) ? '' : this.event_info['catch_copy'],
                'event_details': (this.event_info['event_details'] == undefined) ? '' : this.event_info['event_details'],
                'event_feature': (this.event_info['event_feature'] == undefined) ? '' : this.event_info['event_feature'],
                'event_recommend': (this.event_info['event_recommend'] == undefined) ? '' : this.event_info['event_recommend'],
                'event_summary': (this.event_info['event_summary'] == undefined) ? '' : this.event_info['event_summary'],
                'event_notes': (this.event_info['event_notes'] == undefined) ? '' : this.event_info['event_notes'],

                'amount1': (this.event_info['amount1'] == undefined) ? '' : this.event_info['amount1'],
                'amount2': (this.event_info['amount2'] == undefined) ? '' : this.event_info['amount2'],
                'amount3': (this.event_info['amount3'] == undefined) ? '' : this.event_info['amount3'],
                'amount4': (this.event_info['amount4'] == undefined) ? '' : this.event_info['amount4'],
                'amount5': (this.event_info['amount5'] == undefined) ? '' : this.event_info['amount5'],
                'amount6': (this.event_info['amount6'] == undefined) ? '' : this.event_info['amount6'],
                'amount7': (this.event_info['amount7'] == undefined) ? '' : this.event_info['amount7'],
                'amount8': (this.event_info['amount8'] == undefined) ? '' : this.event_info['amount8'],

                'customer_mail': (this.event_info['customer_mail'] == undefined) ? '' : this.event_info['customer_mail'],
            }
            const serializedArray = JSON.stringify(event)
            localStorage.setItem('luna_event_entry', serializedArray)

            window.location.href = "/event/entry/question2"
        },
        isEventNext() {
            if (this.thumbnail.length == 0) {
                return false
            }

            if (this.event_at == null) {
                return false
            }
            else if (this.event_at == '') {
                return false
            }

            if (this.event_type == null) {
                return false
            }
            else if (this.event_type.length == 0) {
                return false
            }
            else if (this.event_type != null) {

                if (this.event_type.value == 0) {
                    if (this.event_at_from_1 == null) {
                        return false
                    }
                    else if (this.event_at_from_1 == '') {
                        return false
                    }

                    if (this.event_at_open_1 == null) {
                        return false
                    }
                    else if (this.event_at_open_1 == '') {
                        return false
                    }
                    if (this.event_at_to_1 == null) {
                        return false
                    }
                    else if (this.event_at_to_1 == '') {
                        return false
                    }
                }
                else if (this.event_type.value == 1) {

                    if (this.event_at_from_1 == null) {
                        return false
                    }
                    else if (this.event_at_from_1 == '') {
                        return false
                    }

                    if (this.event_at_open_1 == null) {
                        return false
                    }
                    else if (this.event_at_open_1 == '') {
                        return false
                    }
                    if (this.event_at_to_1 == null) {
                        return false
                    }
                    else if (this.event_at_to_1 == '') {
                        return false
                    }

                    if (this.event_at_from_2 == null) {
                        return false
                    }
                    else if (this.event_at_from_2 == '') {
                        return false
                    }

                    if (this.event_at_open_2 == null) {
                        return false
                    }
                    else if (this.event_at_open_2 == '') {
                        return false
                    }
                    if (this.event_at_to_2 == null) {
                        return false
                    }
                    else if (this.event_at_to_2 == '') {
                        return false
                    }
                }
                else if (this.event_type.value == 2) {

                    if (this.event_at_from_1 == null) {
                        return false
                    }
                    else if (this.event_at_from_1 == '') {
                        return false
                    }

                    if (this.event_at_open_1 == null) {
                        return false
                    }
                    else if (this.event_at_open_1 == '') {
                        return false
                    }
                    if (this.event_at_to_1 == null) {
                        return false
                    }
                    else if (this.event_at_to_1 == '') {
                        return false
                    }

                    if (this.event_at_from_2 == null) {
                        return false
                    }
                    else if (this.event_at_from_2 == '') {
                        return false
                    }

                    if (this.event_at_open_2 == null) {
                        return false
                    }
                    else if (this.event_at_open_2 == '') {
                        return false
                    }
                    if (this.event_at_to_2 == null) {
                        return false
                    }
                    else if (this.event_at_to_2 == '') {
                        return false
                    }

                    if (this.event_at_from_3 == null) {
                        return false
                    }
                    else if (this.event_at_from_3 == '') {
                        return false
                    }

                    if (this.event_at_open_3 == null) {
                        return false
                    }
                    else if (this.event_at_open_3 == '') {
                        return false
                    }
                    if (this.event_at_to_3 == null) {
                        return false
                    }
                    else if (this.event_at_to_3 == '') {
                        return false
                    }
                }
            }

            if (this.is_player == null) {
                return false
            }
            else if (this.is_player.length == 0) {
                return false
            }

            if (this.address.length == 0) {
                return false
            }
            else if (this.address.length > 200) {
                return false
            }

            if (this.area_value == null) {
                return false
            }
            else if (this.area_value.length == 0) {
                return false
            }

            if (this.member_count < 1) {
                return false
            }

            if (this.organizer.length == 0) {
                return false
            }

            if (this.myCroppa == null) {
                return false
            }
            else if (!(this.myCroppa.generateDataUrl() != '')) {
                return false
            }

            return true
        },
        addPlayerInput() {
            let player = { value: "" }
            this.players.push(player)
        },
        rmPlayerInput(index) {
            this.players.splice(index, 1)
        },
        rmEventInfo() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                localStorage.removeItem('luna_event_entry')
            }
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        setPlayerInput() {
            if (this.is_player == null) {
                this.player_type = 0
            }
            else if (this.is_player.value == 0) {
                this.player_type = 0
            }
            else if (this.is_player.value == 1) {
                this.player_type = 1
            }

            if (this.players.length == 0) {
                let player = { value: "" }
                this.players.push(player)
            }
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.initEvent()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.initEvent()
            }
        }
        else {
            this.isAuth()
            this.initEvent()
        }
    },
};
</script>

<style scoped>
small {
    color: #5538EE;
}

.select_sex {
    border: 0px;
}

.vs__dropdown-toggle {
    border-top: 0px;
    border-right: 0px;
    border-left: 0px;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
}

.vs__selected-options {
    color: #cdcfd0;
}

.sub_windows {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
}

.croppa-container {
    background-color: #fff;
    border-radius: 8px;
}
</style>
